/* =============================================================
   rv2.js — Reverse Formula «a pagine» (sections/rv-hub.liquid e rv-pagina.liquid). 30-09-2026, secondo giro.
   Cosa fa, nell'ordine in cui si vede:
   1. l'apertura: la frase si accende parola per parola (sfumata, non a scatti), poi restano i marchi al centro;
   2. l'introduzione va A PASSI: la scena resta ferma, lo scorrimento si ferma a ogni schermata (aggancio del
      browser, come prima) e a ogni passo cambia lo sfondo e il testo;
   3. sui numeri romani, passando col mouse esce l'anteprima di quel passaggio;
   4. i sette passaggi stanno tutti in questa pagina: scorrendo, il titolo di ognuno sale da solo dal centro
      dello schermo fino alla barra in cima, e sotto arriva il contenuto. Nessun clic (Stefano, 30-09).
      A destra la guida dice a che passaggio sei, in cima una barra sottile dice quanto manca;
   5. i video: ognuno prende il formato che il browser sa leggere, va SOPRA la foto di anteprima (che sfuma via),
      parte quando serve e si ferma quando esce.
   ============================================================= */
(function () {
  var root = document.querySelector('[data-rv2]');
  if (!root) return;

  var mq = window.matchMedia ? function (q) { return window.matchMedia(q).matches; } : function () { return false; };
  var fermo = mq('(prefers-reduced-motion: reduce)');
  var conMouse = window.matchMedia ? mq('(hover: hover) and (pointer: fine)') : true;
  var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) { return setTimeout(function () { f(Date.now()); }, 16); };
  var adesso = function () { return (window.performance && performance.now) ? performance.now() : Date.now(); };
  var morbida = function (p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; };
  var lista = function (sel, dove) { return Array.prototype.slice.call((dove || root).querySelectorAll(sel)); };

  /* ---------- le parole che si accendono ---------- */
  function aParole(el) {
    if (el.getAttribute('data-pronto')) return Array.prototype.slice.call(el.getElementsByTagName('i'));
    /* se la frase è scritta riga per riga, le righe restano: si accendono le parole DENTRO ognuna */
    var righe = el.querySelectorAll('.rv2-riga-t');
    var dove = righe.length ? Array.prototype.slice.call(righe) : [el];
    var pezzi = [];
    dove.forEach(function (box) {
      var testo = box.textContent.replace(/\s+/g, ' ').trim();
      box.textContent = '';
      testo.split(' ').forEach(function (p, i) {
        if (i) box.appendChild(document.createTextNode(' '));
        var w = document.createElement('i');
        w.textContent = p;
        box.appendChild(w);
        pezzi.push(w);
      });
    });
    el.classList.add('rv2-parole');
    el.setAttribute('data-pronto', '1');
    return pezzi;
  }
  function accendi(parole, si) {
    if (parole.attese) parole.attese.forEach(clearTimeout);
    parole.attese = [];
    if (!si) { parole.forEach(function (w) { w.classList.remove('is-on'); }); return; }
    parole.forEach(function (w, i) {
      parole.attese.push(setTimeout(function () { w.classList.add('is-on'); }, fermo ? 0 : i * 46));
    });
  }

  /* ---------- i video ---------- */
  var prova = document.createElement('video');
  var puo = function (t) { return prova.canPlayType(t) === 'probably' || prova.canPlayType(t) === 'maybe'; };
  var forma = 'h264';
  if (puo('video/mp4; codecs="hvc1.1.6.L93.B0"')) forma = 'hevc';
  if (puo('video/mp4; codecs="av01.0.05M.08"')) forma = 'av1';
  var tutti = [];
  var sbloccato = false;
  function sblocca() {
    if (sbloccato) return;
    sbloccato = true;
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (e) {
      window.addEventListener(e, function () { tutti.forEach(parti); }, { once: true, passive: true });
    });
  }
  function parti(v) { var p = v.play(); if (p && p.catch) p.catch(sblocca); }
  function video(box) {
    if (!box) return null;
    if (box.getAttribute('data-fatto')) return box.querySelector('video');
    var src = box.getAttribute('data-' + forma) || box.getAttribute('data-h264');
    if (!src) return null;
    box.setAttribute('data-fatto', '1');
    var v = document.createElement('video');
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.preload = 'auto';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('autoplay', ''); v.setAttribute('aria-hidden', 'true');
    v.className = 'rv2-video';
    v.src = src;
    box.appendChild(v);                       /* SOPRA la foto di anteprima, non sotto */
    var foto = box.querySelector('img');
    var acceso = function () { v.classList.add('is-on'); if (foto) foto.classList.add('is-via'); };
    v.addEventListener('playing', acceso);
    v.addEventListener('loadeddata', function () { if (v.readyState >= 2) parti(v); });
    tutti.push(v);
    parti(v);
    return v;
  }
  var conVideo = lista('[data-rv2-video]');
  if ('IntersectionObserver' in window) {
    var ioV = new IntersectionObserver(function (voci) {
      voci.forEach(function (x) {
        if (x.isIntersecting) { var v = video(x.target); if (v && v.paused) parti(v); }
        else { var g = x.target.querySelector('video'); if (g && !g.paused) g.pause(); }
      });
    }, { rootMargin: '150% 0px 150% 0px' });
    conVideo.forEach(function (b) { ioV.observe(b); });
  } else {
    conVideo.forEach(video);
  }

  /* ---------- il velo per passare da una pagina all'altra ---------- */
  var velo = document.createElement('div');
  velo.className = 'rv2-velo';
  document.body.appendChild(velo);
  window.addEventListener('pageshow', function () { velo.classList.remove('is-on'); });

  /* ---------- 1. l'apertura ---------- */
  function mostraGuida() {                        /* quanto manca: compare con i marchi.
                                                     La guida a destra no: esce solo dai passaggi in poi
                                                     (Stefano, 30-09), la accende scorri() */
    var b = document.querySelector('.rv3-avanzamento');
    if (b) b.classList.add('is-on');
  }
  var apertura = root.querySelector('[data-rv2-apertura]');
  var marchi = root.querySelector('[data-rv2-marchi]');
  var visto = false;
  try { visto = sessionStorage.getItem('rv-apertura') === '1'; } catch (e) {}

  function apri() {
    if (!apertura || apertura.hidden) return;
    apertura.classList.add('is-via');
    try { sessionStorage.setItem('rv-apertura', '1'); } catch (e) {}
    setTimeout(function () { apertura.hidden = true; }, 1000);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (marchi) marchi.classList.add('is-on');
    mostraGuida();
  }
  if (apertura && !visto) {
    var tutte = [];
    lista('.rv2-apertura__riga', apertura).forEach(function (r) { tutte = tutte.concat(aParole(r)); });
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (fermo) {
      tutte.forEach(function (w) { w.classList.add('is-on'); });
      setTimeout(apri, 1200);
    } else {
      tutte.forEach(function (w, i) { setTimeout(function () { w.classList.add('is-on'); }, 460 + i * 88); });
      setTimeout(apri, 460 + tutte.length * 88 + 1400);
    }
    ['wheel', 'touchstart', 'keydown', 'click'].forEach(function (e) {
      window.addEventListener(e, apri, { once: true, passive: true });
    });
  } else if (apertura) {
    apertura.hidden = true;
    if (marchi) marchi.classList.add('is-on');
    mostraGuida();
  } else if (marchi) {
    marchi.classList.add('is-on');
    marchi.classList.add('is-su');
    mostraGuida();
  }

  /* ---------- 2. l'introduzione a passi ---------- */
  var intro = root.querySelector('[data-rv2-intro]');
  var passo = function () {};
  if (intro) {
    var passi = lista('.rv2-passo', intro);
    var sfondi = lista('.rv2-sfondo', intro);
    var frasi = passi.map(function (p) { var f = p.querySelector('.rv2-frase'); return f ? aParole(f) : null; });
    var attuale = -1;
    passo = function () {
      var r = intro.getBoundingClientRect();
      var h = window.innerHeight;
      var i = Math.floor((-r.top + h * 0.5) / h);
      if (i < 0) i = 0;
      if (i > passi.length - 1) i = passi.length - 1;
      if (i === attuale) return;
      attuale = i;
      passi.forEach(function (p, k) {
        var on = k === i;
        p.classList.toggle('is-on', on);
        if (frasi[k]) accendi(frasi[k], on);
      });
      var quale = passi[i].getAttribute('data-sfondo') || '0';
      sfondi.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-s') === quale); });
      if (marchi) marchi.classList.toggle('is-su', i > 0);
    };
    window.addEventListener('scroll', passo, { passive: true });
    window.addEventListener('resize', passo);
    passo();
  }

  /* ---------- 3. l'anteprima sui numeri romani ---------- */
  var numeri = root.querySelector('[data-rv2-numeri]');
  if (numeri && conMouse) {
    var ant = numeri.querySelector('[data-rv2-anteprima]');
    var antFoto = ant && ant.querySelector('img');
    var antNome = ant && ant.querySelector('p');
    var voci = lista('.rv2-numeri a', numeri);
    if (ant && antFoto) {
      var sopra = numeri.parentNode;
      var spegni = function () {
        ant.classList.remove('is-on');
        numeri.classList.remove('is-sopra');
        if (sopra && sopra.classList) sopra.classList.remove('rv2-con-anteprima');
        voci.forEach(function (v) { v.classList.remove('is-on'); });
      };
      voci.forEach(function (v) {
        v.addEventListener('mouseenter', function () {
          var f = v.getAttribute('data-foto');
          if (f && antFoto.getAttribute('src') !== f) antFoto.setAttribute('src', f);
          if (antNome) antNome.textContent = (v.getAttribute('data-n') || '') + ' ' + (v.getAttribute('data-nome') || '');
          voci.forEach(function (x) { x.classList.toggle('is-on', x === v); });
          numeri.classList.add('is-sopra');
          if (sopra && sopra.classList) sopra.classList.add('rv2-con-anteprima');
          ant.classList.add('is-on');
        });
        v.addEventListener('focus', function () { v.dispatchEvent(new Event('mouseenter')); });
      });
      numeri.addEventListener('mouseleave', spegni);
    }
  }

  /* ---------- 4. i passaggi: il titolo sale DA SOLO mentre scorri (nessun clic) ---------- */
  var ALTA = 32;                                   /* metà della barra: dove si ferma il titolo */
  var GRANDE = 21;                                 /* quanto è grande il titolo al centro (sul telefono meno) */
  var misuraGrande = function () { GRANDE = window.innerWidth < 750 ? 17 : 21; };
  misuraGrande();
  window.addEventListener('resize', misuraGrande);
  var capitoli = lista('[data-rv3-cap]').map(function (c) {
    return {
      el: c,
      i: c.getAttribute('data-i'),
      crema: c.querySelector('.rv2-pezzi'),
      riga: c.querySelector('[data-rv3-riga]'),
      numero: c.querySelector('.rv2-riga__n'),
      titolo: c.querySelector('.rv2-riga__t'),
      testo: c.querySelector('[data-rv3-testo]')
    };
  });
  var guida = document.querySelector('[data-rv3-guida]');
  var vociGuida = guida ? lista('li', guida) : [];
  var avanti = document.querySelector('[data-rv3-avanti]');
  if (capitoli.length) {
    var inCoda = false;
    var attivo = null;
    var scorri = function () {
      inCoda = false;
      var h = window.innerHeight;
      var y = window.pageYOffset;
      /* prima si legge tutto, poi si scrive: così il browser non ricalcola sette volte */
      var misure = capitoli.map(function (c) { return c.el.getBoundingClientRect(); });
      var creme = capitoli.map(function (c) { return c.crema ? c.crema.getBoundingClientRect() : null; });
      var quale = null;
      /* due controlli diversi: cosa c'è sotto la barra in cima e cosa c'è a metà schermo (dov'è la guida) */
      root.classList.toggle('rv2-chiaro', creme.some(function (r) { return r && r.top <= 70 && r.bottom > 70; }));
      root.classList.toggle('rv2-chiaro-mezzo', creme.some(function (r) { return r && r.top <= h * 0.5 && r.bottom > h * 0.5; }));
      misure.forEach(function (r, k) {
        var p = (-r.top) / (h * 0.62);
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
        var c = capitoli[k];
        if (c.riga) c.riga.style.transform = 'translateY(' + ((1 - p) * (h / 2 - ALTA)).toFixed(1) + 'px)';
        if (c.titolo) c.titolo.style.fontSize = (GRANDE - (GRANDE - 15) * p).toFixed(2) + 'px';
        /* il numero romano sparisce salendo: in cima finirebbe sopra il logo Reverse Formula */
        if (c.numero) c.numero.style.opacity = (1 - Math.min(1, p * 1.35)).toFixed(2);
        if (c.testo) c.testo.classList.toggle('is-on', p > 0.7);
        if (r.top <= h * 0.5 && r.bottom > h * 0.5) quale = c.i;
      });
      if (guida) guida.classList.toggle('is-on', quale !== null);
      if (quale !== attivo) {
        attivo = quale;
        root.classList.toggle('rv2-incap', quale !== null);   /* sul telefono i marchi lasciano il posto al titolo */
        vociGuida.forEach(function (li) {
          var v = li.querySelector('a').getAttribute('data-i');
          li.classList.toggle('is-on', v === quale);
          li.classList.toggle('is-fatto', quale !== null && Number(v) < Number(quale));
        });
      }
      if (avanti) {
        var tot = document.documentElement.scrollHeight - h;
        avanti.style.width = (tot > 0 ? Math.min(100, Math.max(0, y / tot * 100)) : 0).toFixed(2) + '%';
      }
    };
    var chiedi = function () { if (!inCoda) { inCoda = true; raf(scorri); } };
    window.addEventListener('scroll', chiedi, { passive: true });
    window.addEventListener('resize', chiedi);
    scorri();
  }

  /* ---------- i salti: numeri romani e guida portano al passaggio, senza strappi ---------- */
  function portaA(el) {
    if (!el) return;
    var meta = Math.round(el.getBoundingClientRect().top + window.pageYOffset);
    var html = document.documentElement;
    var aggancio = html.classList.contains('rv2-passi');
    if (fermo) { window.scrollTo(0, meta); return; }
    if (aggancio) html.classList.remove('rv2-passi');   /* l'aggancio del browser storce i salti: si rimette dopo */
    var da = window.pageYOffset, t0 = adesso(), ms = Math.min(950, 380 + Math.abs(meta - da) * 0.06);
    (function giro() {
      var q = Math.min(1, (adesso() - t0) / ms);
      var e = q < .5 ? 4 * q * q * q : 1 - Math.pow(-2 * q + 2, 3) / 2;
      window.scrollTo(0, da + (meta - da) * e);
      if (q < 1) raf(giro);
      else if (aggancio) setTimeout(function () { html.classList.add('rv2-passi'); }, 60);
    })();
  }
  lista('.rv2-numeri a, .rv3-guida a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = (a.getAttribute('href') || '').slice(1);
      var el = id && document.getElementById(id);
      if (!el || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      portaA(el);
    });
  });

  /* ---------- «Continua» in fondo alle pagine singole dei passaggi ---------- */
  lista('a.rv2-poi').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      velo.classList.add('is-on');
      setTimeout(function () { window.location.href = a.href; }, fermo ? 0 : 300);
    });
  });

  /* ---------- 5. la pagina del passaggio: il titolo è GIÀ in cima (è salito nel clic), si apre la copertina ---------- */
  raf(function () { raf(function () { root.classList.add('rv2-dentro'); }); });

  /* ---------- l'indice della parte chiara segue il pezzo che stai leggendo ---------- */
  lista('[data-rv2-indice]').forEach(function (indice) {
    if (!('IntersectionObserver' in window)) return;
    var righe = lista('a', indice);
    var pezzi = righe.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
    var ioP = new IntersectionObserver(function (voci) {
      voci.forEach(function (r) {
        if (!r.isIntersecting) return;
        righe.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href').slice(1) === r.target.id); });
      });
    }, { rootMargin: '-25% 0px -60% 0px' });
    pezzi.forEach(function (p) { ioP.observe(p); });
  });
})();
